import axios from "axios";
import { BE_SERVER_ENDPOINT, API_PROTOCOL } from "../constants/configs.js";
import { CONFIG_FETCHER_ACTIONS } from "../actions/configFetcherActions";

const ConfigDataFetcher = {
    fetchConfigData: function (options) {
        return dispatch => {
            let url = API_PROTOCOL + BE_SERVER_ENDPOINT + "/v2.0/configs/frontend_configs/pilot/" + options.pilotId;
            axios.get(url).then(response => {
                dispatch({
                    type: CONFIG_FETCHER_ACTIONS.FETCH_CONFIG_DATA_SUCCESS,
                    payload: response.data.payload
                });
            }).catch(error => {
                dispatch({
                    type: CONFIG_FETCHER_ACTIONS.FETCH_CONFIG_DATA_ERROR,
                    payload: error
                });
            });
        };
    },
    fetchColorPaletteData: (options) => {
        const defaultPalette = "default_palette_ui";
        return dispatch => {
            let url = null;
            if (!options.paletteType) {
                url = API_PROTOCOL + BE_SERVER_ENDPOINT + "/v2.0/configs/" + defaultPalette + "/pilot/" + options.pilotId;
            } else {
                url = API_PROTOCOL + BE_SERVER_ENDPOINT + "/v2.0/configs/" + options.paletteType + "/pilot/" + options.pilotId;
            }
            axios.get(url).then(response => {
                dispatch({
                    type: CONFIG_FETCHER_ACTIONS.FETCH_COLOR_PALETTE_DATA_SUCCESS,
                    payload: {
                        paletteType: options.paletteType ? options.paletteType : defaultPalette,
                        data: response.data.payload
                    }
                });
            }).catch(error => {
                dispatch({
                    type: CONFIG_FETCHER_ACTIONS.FETCH_COLOR_PALETTE_DATA_ERROR,
                    payload: error
                });
            });
        }
    }
};

export default ConfigDataFetcher;
